import api from './api';
import { mutate } from 'swr';

export function StripRedirectionUrl() {
  const urls = {
    successUrl: '/account#billing',
    cancelUrl: '/account?plan=true#billing'
  };

  if (window.location.href.includes('plan-setup')) {
    urls.successUrl = '/account#billing';
    urls.cancelUrl = '/signup/plan-setup' ;
  } else if (window.location.href.includes('influencer-payments') || window.location.href.includes('influencer')) {
    urls.successUrl = '/influencer/dashboard';
    urls.cancelUrl = '/account#billing';
  } else if (window.location.href.includes('creator')) {
    urls.successUrl = '/creator/dashboard';
    urls.cancelUrl = '/account?plan=true#billing';
  } else if (window.location.href.includes('artist')) {
    urls.successUrl = '/artist/dashboard';
    urls.cancelUrl = '/account?plan=true#billing';
  } else if (window.location.href.includes('account')) {
    urls.successUrl = '/account#billing';
    urls.cancelUrl = '/account?plan=true#billing';
  }

  return urls;
}

const redirectToStripe = async (priceId?: string, isUserAlreadySubscribed?: boolean) => {
  try {
    type PayloadType = {
      successUrl?: string;
      cancelUrl?: string;
      returnUrl?: string;
      priceId?: string;
      mode?: string;
    };

    const payload: PayloadType = {};
    let route: string;

    if (priceId && !isUserAlreadySubscribed) {
      payload.successUrl = `${window.location.host.startsWith('localhost') ? 'http://' + window.location.host + '' : ''}${StripRedirectionUrl().successUrl}`;
      payload.cancelUrl = `${window.location.host.startsWith('localhost') ? 'http://' + window.location.host + '' : ''}${StripRedirectionUrl().cancelUrl}`;
      payload.priceId = priceId;
      (payload.mode = 'payment'), (route = 'subscriptions/v1/plans/checkout/me');
    } else {
      payload.returnUrl = `${window.location.host.startsWith('localhost') ? 'http://' + window.location.host + '' : ''}${StripRedirectionUrl().successUrl}`;
      route = 'subscriptions/v1/plans/manage/me';
    }

    const response = await api.post(route, payload);

    if (response && response.status === 200) {
      const url = response.data.url;
      await mutate('/subscriptions/v1/account');
      if (url) window.location.href = url;
    }
  } catch (e) {
    console.error(e);
  } finally {
    localStorage.removeItem('planId');
  }
};

export default redirectToStripe;
